<div class="d-grid gap-3 gap-md-4">
  <div class="" *ngFor="let bannerFtp of bannersFtp">
    <a [href]="bannerFtp.url" target="_blank">
      <img class="border rounded" [src]="bannerFtp.image" alt="" width="100%">
    </a>
  </div>
</div>